type Props = {
  children: string;
  dotColor?: string;
};

export function SectionLabel({ children, dotColor = '#EAB308' }: Props) {
  return (
    <p class="flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-blue-700 mb-2">
      <span class="inline-block w-3 h-3 rounded-full" style={`background-color: ${dotColor}`} />
      {children}
    </p>
  );
}
